import {Component, EventEmitter, Input, OnInit, Output} from '@angular/core';

@Component({
  selector: 'app-field-value',
  templateUrl: './field-value.component.html',
  styleUrls: ['./field-value.component.scss']
})
export class FieldValueComponent implements OnInit {

  @Input() field: any;

  @Input() values: any[];

  @Output() add = new EventEmitter();

  showPopup: boolean;

  intermediateValue: string;

  shownValue;

  constructor() { }

  ngOnInit() {
  }

  pickValue(value) {
    this.shownValue = value.value;
    this.add.next(value);
    this.showPopup = false;
  }

  save() {
    this.shownValue = this.intermediateValue;
    this.add.next({field: this.field._id, value: this.intermediateValue});
    this.showPopup = false;
  }

}



// WEBPACK FOOTER //
// ./client/app/components/shared/field-value/field-value.component.ts